import { useMergedConfigStore } from 'src/stores/merged_config.js'

import { uploadAttachment } from 'src/services/attachment_upload/attachment_upload.js'

const mediaUpload = {
  data() {
    return {
      uploadCount: 0,
      uploadReady: true,
    }
  },
  computed: {
    uploading() {
      return this.uploadCount > 0
    },
  },
  methods: {
    onClick() {
      if (this.uploadReady) {
        this.$refs.input.click()
      }
    },
    // the original goes along: the post form can upload it again with the
    // other compression choice
    async uploadFile(file) {
      const config = useMergedConfigStore().mergedConfig
      this.$emit('uploading')
      this.uploadCount++
      try {
        const { fileData, compressed } = await uploadAttachment(file, {
          compress: this.compress ?? config.imageCompression,
          jpegOnly: config.alwaysUseJpeg,
        })
        this.$emit('uploaded', fileData, { original: file, compressed })
      } catch (error) {
        this.$emit('upload-failed', error.errorKey ?? 'default', error.args)
      } finally {
        this.decreaseUploadCount()
      }
    },
    decreaseUploadCount() {
      this.uploadCount--
      if (this.uploadCount === 0) {
        this.$emit('all-uploaded')
      }
    },
    clearFile() {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    multiUpload(files) {
      for (const file of files) {
        this.uploadFile(file)
      }
    },
    // the input empties itself: picking the same file again (after a
    // failed upload) fires change again
    change({ target }) {
      const files = [...target.files]
      target.value = ''
      this.multiUpload(files)
    },
  },
  props: {
    dropFiles: Object,
    // compress pictures before uploading; unset: the global setting
    compress: { type: Boolean, default: undefined },
    disabled: Boolean,
    normalButton: Boolean,
    acceptTypes: {
      type: String,
      default: '*/*',
    },
  },
  watch: {
    dropFiles: function (fileInfos) {
      if (!this.uploading) {
        this.multiUpload(fileInfos)
      }
    },
  },
}

export default mediaUpload
